"use strict";

import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";

const axios = require("axios");

const Schools = () => {
  const [states, setStates] = useState([]);
  const [conference, setConference] = useState([]);
  const [filter, setFilter] = useState("DEFAULT");

  useEffect(() => {
    const fetchData = async () => {
      const schoolResponse = await axios(
        "https://allintovote.staging.wpengine.com/wp-json/wp/v2/pages/180"
      );
      const fetchConference = await axios(
        "https://allintovote.staging.wpengine.com/wp-json/wp/v2/school_conference"
      );
      setStates(schoolResponse.data.acf.school);
      setConference(fetchConference.data);
    };
    fetchData();
  }, []);

  const changeValue = (e) => {
    setFilter(e.target.options[e.target.selectedIndex].value);
  };

  return (
    <>
      <div className="filter-dropdown">
        <span>Filter by Conference</span>
        <select onChange={changeValue}>
          <option value="DEFAULT">All Schools</option>
          {conference.map((value) => {
            return (
              <option key={value.id} value={value.id}>
                {value.name}
              </option>
            );
          })}
        </select>
      </div>
      <div className="filter-stats">
        <div className="filter-stat">
          <span>30</span>
          <p>
            <svg className="icon icon-hand-heart">
              <use xlinkHref="#icon-hand-heart" />
            </svg>
            Total pledges to vote
          </p>
        </div>
        <div className="filter-stat">
          <span>14</span>
          <p>Student pledges to vote</p>
        </div>
      </div>

      <table className="school-ranking">
        <thead>
          <tr className="ranking-header">
            <th className="header-rank">Rank</th>
            <th className="header-college">College</th>
            <th className="header-student">% of Students</th>
            <th className="header-pledge"># of pledges</th>
          </tr>
        </thead>
        <tbody>
          {states
            .filter(
              (value) =>
                filter === "DEFAULT" ||
                value.conference.some((element) => element == filter)
            )
            .map((filteredName, index) => (
              <tr key={index}>
                <td className="school-rank">{index + 1}</td>
                <td className="school-name">
                  {filteredName.school_name ? filteredName.school_name : ""}
                </td>
                <td className="school-percentage">
                  {filteredName.students ? filteredName.students : ""}
                </td>
                <td className="school-pledge">
                  {filteredName.pledges ? filteredName.pledges : ""}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

const school = document.querySelector(".pledge-school_rankings");
school ? ReactDOM.render(<Schools />, school) : null;
